import * as GeneratedApis from '../../vendor/openapi-public-v1/dist/esm/apis/index.js';
import { BaseAPI, JSONApiResponse, VoidApiResponse } from '../../vendor/openapi-public-v1/dist/esm/runtime.js';
import type { PageMetaschema } from '../../vendor/openapi-public-v1/dist/esm/models/PageMetaschema.js';
import type {
  ChatRunEventArtifactUpdateschema,
  TopologyPathTraceRequestschema,
  TopologyPathTraceResponseschema
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';
import {
  ChatRunEventArtifactUpdateschemaFromJSON as GeneratedChatRunEventArtifactUpdateschemaFromJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/ChatRunEventArtifactUpdateschema.js';

export {
  Configuration,
  DefaultConfig,
  ResponseError
} from '../../vendor/openapi-public-v1/dist/esm/runtime.js';

// Site Intelligence is consumed through the generated SitesApi and its public
// contract types, rather than handwritten JSON-wire approximations.
export type {
  SiteIntelligenceBfd,
  SiteIntelligenceBfdEvidence,
  SiteIntelligenceBfdFindingDetailResponse,
  SiteIntelligenceBfdObservation,
  SiteIntelligenceBfdResponse,
  SiteIntelligenceBgp,
  SiteIntelligenceBgpResponse,
  SiteIntelligenceDevice,
  SiteIntelligenceFindingPreview,
  SiteIntelligenceNamingFindingDetailResponse,
  SiteIntelligenceNamingListResponse,
  SiteIntelligenceNamingReviewQuestionListResponse,
  SiteIntelligenceRouting,
  SiteIntelligenceBgpEvidence,
  SiteIntelligenceRoutingFinding,
  SiteIntelligenceBgpFindingDetailResponse,
  SiteIntelligenceRoutingFindingListResponse,
  SiteIntelligenceRoutingInstancePreview,
  SiteIntelligenceBgpObservation,
  SiteIntelligenceBgpOperatorEvidence,
  SiteIntelligenceBgpOperatorMeasure,
  SiteIntelligenceRoutingResponse,
  SiteIntelligenceRoutingReviewQuestion,
  SiteIntelligenceRoutingReviewQuestionListResponse,
  SiteIntelligenceRoutingStatement,
  SiteIntelligenceSnapshot,
  SiteIntelligenceSummary,
  SiteIntelligenceTopologyFindingDetailResponse,
  SiteIntelligenceTopologyFindingListResponse,
  SiteIntelligenceTopologyResponse,
  SiteIntelligenceTopologyReviewQuestionListResponse,
  SiteIntelligenceVlanDetailResponse,
  SiteIntelligenceVlanFinding,
  SiteIntelligenceVlanListResponse
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';
export type SiteIntelligenceReviewQuestionListResponse =
  import('../../vendor/openapi-public-v1/dist/esm/models/index.js').SiteIntelligenceNamingReviewQuestionListResponse
  | import('../../vendor/openapi-public-v1/dist/esm/models/index.js').SiteIntelligenceTopologyReviewQuestionListResponse;

export type {
  PingMeshCell,
  PingMeshCandidate,
  PingMeshMetric,
  PingMeshMetricSample,
  PingMeshQueryResponse,
  PingMeshLatestResultschema,
  PingMeshHistoryschema,
  PingMeshMetricValueschema,
  PingMeshMetricRangeschema,
  PingMeshDistributionschema,
  PingMeshRangeschema
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';

export {
  SiteIntelligenceSummaryToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceSummary.js';
export {
  SiteIntelligenceBfdResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceBfdResponse.js';
export {
  SiteIntelligenceBfdFindingDetailResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceBfdFindingDetailResponse.js';
export {
  SiteIntelligenceRoutingResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceRoutingResponse.js';
export {
  SiteIntelligenceBgpResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceBgpResponse.js';
export {
  SiteIntelligenceRoutingFindingListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceRoutingFindingListResponse.js';
export {
  SiteIntelligenceRoutingReviewQuestionListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceRoutingReviewQuestionListResponse.js';
export {
  SiteIntelligenceBgpFindingDetailResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceBgpFindingDetailResponse.js';
export {
  SiteIntelligenceTopologyResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceTopologyResponse.js';
export {
  SiteIntelligenceTopologyFindingListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceTopologyFindingListResponse.js';
export {
  SiteIntelligenceTopologyReviewQuestionListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceTopologyReviewQuestionListResponse.js';
export {
  SiteIntelligenceTopologyFindingDetailResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceTopologyFindingDetailResponse.js';
export {
  SiteIntelligenceNamingListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceNamingListResponse.js';
export {
  SiteIntelligenceNamingReviewQuestionListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceNamingReviewQuestionListResponse.js';
export {
  SiteIntelligenceNamingFindingDetailResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceNamingFindingDetailResponse.js';
export {
  SiteIntelligenceVlanListResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceVlanListResponse.js';
export {
  SiteIntelligenceVlanDetailResponseToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/SiteIntelligenceVlanDetailResponse.js';

export const AuthApi = GeneratedApis.AuthApi;
export const OrganizationsApi = GeneratedApis.OrganizationsApi;
export const IdPConnectionsApi = GeneratedApis.IdPConnectionsApi;
export const IdPMappingRulesApi = GeneratedApis.IdPMappingRulesApi;
export const SecretsApi = GeneratedApis.SecretsApi;
export const CredentialsApi = GeneratedApis.CredentialsApi;
export const CredentialStoresApi = GeneratedApis.CredentialStoresApi;
export const CredentialAssignmentsApi = GeneratedApis.CredentialAssignmentsApi;
export const MetricsApi = GeneratedApis.MetricsApi;
export const RolesApi = GeneratedApis.RolesApi;
export const APIKeysApi = GeneratedApis.APIKeysApi;
export const AuditLogApi = GeneratedApis.AuditLogApi;
export const IntegrationsApi = GeneratedApis.IntegrationsApi;
export const CloudIntegrationsApi = GeneratedApis.CloudIntegrationsApi;
export const SitesApi = GeneratedApis.SitesApi;
export const ConnectorClustersApi = GeneratedApis.ConnectorClustersApi;
export const ConnectorsApi = GeneratedApis.ConnectorsApi;
export const DevicesApi = GeneratedApis.DevicesApi;
export const CMDBReconciliationApi = GeneratedApis.CMDBReconciliationApi;
export const TopologyApi = GeneratedApis.TopologyApi;
export const VisibilityApi = GeneratedApis.VisibilityApi;
export const MembershipsApi = GeneratedApis.MembershipsApi;
export const InvitationsApi = GeneratedApis.InvitationsApi;
export const DiscoveryApi = GeneratedApis.DiscoveryApi;
export const InventoryApi = GeneratedApis.InventoryApi;
export const ChangeValidationsApi = GeneratedApis.ChangeValidationsApi;
export const ChatRunsApi = GeneratedApis.ChatRunsApi;

export {
  CredentialKindschema,
  CredentialApiAuthTypeschema,
  CredentialDetailsApiRestAuthApiKeyInEnum,
  SecretTypeschema,
  SnmpV3SecurityLevelschema,
  SnmpV3AuthProtocolschema,
  SnmpV3PrivProtocolschema,
  CredentialAssignmentAllOfScopeOneOfTypeEnum,
  CredentialAssignmentAllOfScopeOneOf1TypeEnum,
  CredentialAssignmentAllOfScopeOneOf2TypeEnum,
  ApiKeyStatusEnum,
  Vendorschema,
  TopologyV2Familyschema,
  TopologyV2ScopeTypeschema,
  SiteSiteTypeEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';
export {
  CMDBAttributeMappingRuleTruthTypeEnum,
  CMDBAttributeMappingRuleNormalizationEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/CMDBAttributeMappingRule.js';
export {
  CMDBAuthorityRuleStrategyEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/CMDBAuthorityRule.js';

export {
  ChatActiveArtifactContextschemaKindEnum,
  ChatActiveArtifactContextschemaSurfaceEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/ChatActiveArtifactContextschema.js';
export {
  ChatInteractContextschemaSurfaceEnum,
  ChatInteractContextschemaToJSON
} from '../../vendor/openapi-public-v1/dist/esm/models/ChatInteractContextschema.js';
export {
  ChatRunEventArtifactUpdateschemaArtifactKindEnum,
  ChatRunEventArtifactUpdateschemaUpdateKindEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/ChatRunEventArtifactUpdateschema.js';
export {
  TopologyArtifactOverlayStateschemaSchemaEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/TopologyArtifactOverlayStateschema.js';
export {
  TopologyPathModeschema as TopologyPathModeValues
} from '../../vendor/openapi-public-v1/dist/esm/models/TopologyPathModeschema.js';
export {
  TopologyOverlayBaseschemaSourceEnum,
  TopologyOverlayBaseschemaTimeModeEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/TopologyOverlayBaseschema.js';
export {
  TopologyOverlayLayerschemaKindEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/TopologyOverlayLayerschema.js';
export {
  TopologyOverlayPatchOpschemaOpEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/TopologyOverlayPatchOpschema.js';
export {
  VisibilityProposalOriginschema
} from '../../vendor/openapi-public-v1/dist/esm/models/VisibilityProposalOriginschema.js';
export {
  VisibilityProposalStatusschema
} from '../../vendor/openapi-public-v1/dist/esm/models/VisibilityProposalStatusschema.js';
export {
  VisibilitySessionModeschema
} from '../../vendor/openapi-public-v1/dist/esm/models/VisibilitySessionModeschema.js';
export {
  VisibilitySessionStateschemaSchemaEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/VisibilitySessionStateschema.js';
export {
  VisibilitySessionStatusschema
} from '../../vendor/openapi-public-v1/dist/esm/models/VisibilitySessionStatusschema.js';
export {
  VisibilityWorkspaceFamilyschema
} from '../../vendor/openapi-public-v1/dist/esm/models/VisibilityWorkspaceFamilyschema.js';

export type { ConfigurationParameters, Middleware } from '../../vendor/openapi-public-v1/dist/esm/runtime.js';

export type ConfigurationClass = import('../../vendor/openapi-public-v1/dist/esm/runtime.js').Configuration;
export type ResponseErrorClass = import('../../vendor/openapi-public-v1/dist/esm/runtime.js').ResponseError;
export type AuthApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').AuthApi;
export type OrganizationsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').OrganizationsApi;
export type IdPConnectionsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').IdPConnectionsApi;
export type IdPMappingRulesApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').IdPMappingRulesApi;
export type SecretsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').SecretsApi;
export type CredentialsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').CredentialsApi;
export type CredentialStoresApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').CredentialStoresApi;
export type CredentialAssignmentsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').CredentialAssignmentsApi;
export type MetricsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').MetricsApi;
export type RolesApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').RolesApi;
export type APIKeysApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').APIKeysApi;
export type AuditLogApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').AuditLogApi;
export type IntegrationsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').IntegrationsApi;
export type CloudIntegrationsApiClass = any;
export type SitesApiClass = any;
export type ConnectorClustersApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').ConnectorClustersApi;
export type ConnectorsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').ConnectorsApi;
export type DevicesApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').DevicesApi;
export type CMDBReconciliationApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').CMDBReconciliationApi;
export type VisibilityApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').VisibilityApi;
export type TopologyApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').TopologyApi & {
  searchTopologyPathEndpoints: (
    requestParameters: {
      orgId: string;
      topologyPathEndpointSearchRequest: TopologyPathEndpointSearchRequest;
    },
    initOverrides?: RequestInit | import('../../vendor/openapi-public-v1/dist/esm/runtime.js').InitOverrideFunction
  ) => Promise<TopologyPathEndpointSearchResponse>;
  traceTopologyPath: (
    requestParameters: {
      orgId: string;
      topologyPathTraceRequest: TopologyPathTraceRequest;
    },
    initOverrides?: RequestInit | import('../../vendor/openapi-public-v1/dist/esm/runtime.js').InitOverrideFunction
  ) => Promise<TopologyPathTraceResponse>;
};
export type MembershipsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').MembershipsApi;
export type InvitationsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').InvitationsApi;
export type DiscoveryApiClass = any;
export type InventoryApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').InventoryApi;
export type ChangeValidationsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').ChangeValidationsApi;
export type ChatRunsApiClass = import('../../vendor/openapi-public-v1/dist/esm/apis/index.js').ChatRunsApi;

export type {
  ArtifactDocument,
  ChangeValidation,
  ChangeValidationComparisonschema,
  ChangeValidationComparisonListResponse,
  ChangeValidationListResponse,
  ChangeValidationObservationschema,
  ChangeValidationObservationListResponse,
  ChangeValidationReport,
  ChangeValidationStageRunSummaryschema,
  ChangeValidationReportSummaryschema
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';

export type {
  CMDBAttributeMappingProfile,
  CMDBAttributeMappingRule,
  CMDBAttributeMappingRulesRequest,
  CMDBAuthorityPolicy,
  CMDBAuthorityPolicyPreview,
  CMDBAuthorityRule,
  CMDBAuthorityRulesRequest,
  CMDBEffectiveAssertion,
  CMDBMeasuredMaturity,
  CMDBMaturityDimension,
  CMDBMaturityDeclaration,
  CMDBMaturityDeclarationRequest,
  CMDBFindingHistory,
  CMDBFindingTransitionRequest,
  CMDBReconciliationRun,
  CMDBDependencyGroup,
  CMDBDependencyGroupsRequest,
  CMDBReconciliationFinding,
  CMDBReconciliationObservation,
  CMDBDiscrepancy,
  CMDBDiscrepancyReport,
  CMDBDeviceCrosswalkResponse,
  CMDBDeviceCrosswalkRow,
  CMDBDeviceCrosswalkSummary,
  CMDBMaturityScore,
  CMDBIdentityAdjudicationRequest,
  CMDBIdentityFinding,
  CMDBIdentityFindingsResponse,
  CMDBIdentityHistory,
  CMDBSourceRecord,
  CMDBSourceRecordHistory,
  CMDBSourceRecordsResponse,
  CMDBSourceRetentionPolicy,
  CMDBSourceRetentionPolicyUpdateRequest,
  CMDBReconciliationPolicy,
  InventoryCMDBConnection,
  InventoryCMDBConnectionsResponse,
  InventoryCMDBDiscrepancyCoverage,
  InventoryCMDBDiscrepancyItem,
  InventoryCMDBDiscrepancyReport,
  InventoryCMDBDiscrepancySummary,
  IntegrationConnection,
  IntegrationConnectionConfig,
  IntegrationConnectionsListResponse,
  IntegrationWebhookConfig,
  IntegrationWebhookProvisioning,
  OAuthStartResponse,
  IntegrationConnectionCMDBBinding,
  IntegrationConnectionCMDBBindingsResponse,
  IntegrationConnectionCMDBAccessCheckItem,
  IntegrationConnectionCMDBAccessCheckPolicy,
  IntegrationConnectionCMDBAccessCheckRequest,
  IntegrationConnectionCMDBAccessCheckResponse,
  IntegrationConnectionCMDBSyncDomain,
  IntegrationConnectionCMDBSyncJob,
  IntegrationConnectionCMDBSourceEvidenceSummary,
  IntegrationConnectionCMDBWritebackPolicy,
  IntegrationConnectionCMDBWritebackPolicyHistoryEntry,
  IntegrationConnectionCMDBWritebackPolicyUpdateRequest,
  IntegrationConnectionCMDBSyncRequest,
  ArtifactContentTopologyschema,
  IntegrationConnectionCMDBSyncResponse,
  IntegrationConnectionCMDBUnboundDevice,
  IntegrationConnectionCMDBUnboundDevicesResponse,
  IntegrationConnectionCMDBWritebackRequest,
  IntegrationConnectionCMDBWritebackResponse,
  IntegrationConnectionCMDBWritebackResult,
  InteractionRoutingRule,
  InteractionRoutingRulesListResponse,
  InteractionTarget,
  InteractionTargetsListResponse,
  ChatActiveArtifactContextschema,
  ChatInteractContextschema,
  ChatRunEventArtifactUpdateschema,
  ChatVisibilitySessionContextschema,
  ProviderDefinition,
  ProviderDefinitionsListResponse,
  TopologyAnnotationTargetschema,
  TopologyArtifactOverlayStateschema,
  TopologyGraphOverlayschema,
  TopologyOverlayBaseschema,
  TopologyOverlayLayerFilterschema,
  TopologyOverlayLayerschema,
  TopologyOverlayPatchOpschema,
  TopologyOverlayPatchschema,
  TopologyOverlaySelectionschema,
  TopologyPathCapabilityGapschema,
  TopologyPathEvidenceGapschema,
  TopologyPathEvidenceLevelschema,
  TopologyPathEvidenceReferenceschema,
  TopologyPathEndpointReferenceschema,
  TopologyPathLayerMetadataschema,
  TopologyPathModeschema,
  TopologyPathOperationschema,
  TopologyPathRenderDecisionschema,
  TopologyPathResultPayloadschema,
  TopologyPathResultschema,
  TopologyPathSetSummaryschema,
  TopologyPathTopologyRefschema,
  TopologyV2Drilldownschema,
  TopologyV2EdgeLabels,
  TopologyV2Edgeschema,
  TopologyV2Graphschema,
  TopologyV2Legendschema,
  TopologyV2LegendNodeRulesInner,
  TopologyV2Limitsschema,
  TopologyV2NodeLabels,
  TopologyV2Nodeschema,
  TopologyV2ParamOptionItemschema,
  TopologyV2ParamOptionsResponse,
  TopologyV2ParamSpecschema,
  TopologyV2ResolveRequest,
  TopologyV2ResolveRequestPatchschema,
  TopologyV2ResolveResponse,
  TopologyV2Scopeschema,
  TopologyV2ViewCatalogItemschema,
  TopologyV2ViewCreateRequest,
  TopologyV2ViewOriginFilterschema,
  TopologyV2ViewOverlayStateschema,
  TopologyV2ViewParamsResponse,
  TopologyV2ViewSaveResponse,
  TopologyV2ViewSaveSourceschema,
  TopologyV2ViewSaveWarningschema,
  TopologyV2ViewSavedLayerSummaryschema,
  TopologyV2ViewScopeModeschema,
  TopologyV2ViewUpdateRequest,
  TopologyV2ViewsListResponse,
  TopologyArtifactOverlayLayerStatusschema,
  TopologyArtifactOverlayStatusDataschema,
  TopologyViewPatchOpschema,
  TopologyViewStreamFrame,
  TopologyViewStreamPatchData,
  TopologyViewStreamSnapshotData,
  VisibilityProposal,
  VisibilityProposalCreateRequest,
  VisibilitySelectedElementschema,
  VisibilitySession,
  VisibilitySessionCreateRequest,
  VisibilitySessionStateschema,
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';

export const TopologyPathEndpointSearchRequestSideEnum = {
  Source: 'source',
  Destination: 'destination'
} as const;

export const TopologyPathEndpointSearchRequestZeroStateModeEnum = {
  BoundedDefaults: 'bounded_defaults',
  Recent: 'recent'
} as const;

export const TopologyPathRequestContextschemaLaunchSurfaceEnum = {
  StandalonePage: 'standalone_page',
  PingMesh: 'ping_mesh'
} as const;

export const TopologyPathTraceGoal = {
  Visualize: 'visualize'
} as const;

export const TopologyPathTraceResponseStatusEnum = {
  Ready: 'ready',
  NeedsClarification: 'needs_clarification',
  NotFound: 'not_found',
  Unsupported: 'unsupported',
  Unavailable: 'unavailable'
} as const;

export interface TopologyPathRequestContextschema {
  launchSurface?: string;
  siteHints?: string[];
  siteType?: string;
}

export interface TopologyPathEndpointSearchRequest {
  side?: string;
  query?: string;
  zeroStateMode?: string;
  requestedMode?: string;
  allowCrossSiteFallback?: boolean;
  limit?: number;
  asOf?: Date;
  context?: TopologyPathRequestContextschema;
}

export interface TopologyPathEndpointSearchResponse {
  status?: string;
  items: Array<{
    kind: string;
    displayName: string;
    summary?: string;
    score?: number;
    matchType?: string;
    reference: any;
    site?: {
      id?: string;
      name?: string;
    };
  }>;
  coverage?: {
    scopeMode?: string;
    itemLimit?: number;
  };
}

export type TopologyPathTraceRequest = TopologyPathTraceRequestschema;
export type TopologyPathTraceResponse = TopologyPathTraceResponseschema;

export type {
  TopologyV2ScopeType,
  TokenResponse,
  TokenIssueResult,
  TokenRequest,
  TokenRequestEmailTx,
  TokenRequestLoginTx,
  TokenRequestOidcTx,
  TokenRequestSamlTx,
  TokenRequestRefresh,
  TokenNextStepPickOrgMembershipsInner,
  DiscoverVerifyResponse,
  DiscoverVerifyResponseMembershipsInner,
  ConnectionChoice,
  Organization,
  Organizationschema,
  OrganizationsListResponse,
  IdpConnection,
  IdpConnectionCreate,
  IdpConnectionschema,
  IdpConnectionUpdate,
  IdpConnectionOidc,
  IdpConnectionOidcCreate,
  IdpConnectionOidcCreateConfig,
  IdpConnectionSaml,
  IdpConnectionSamlCreate,
  IdpConnectionSamlCreateConfig,
  IdpOidcConfigschema,
  IdpSamlConfigschema,
  RoleMappingRule,
  RoleMappingRuleCreate,
  RoleMappingRuleCreateMatchSourceEnum,
  RoleMappingRuleCreateMatchOperatorEnum,
  RoleMappingRuleCreateResult,
  RoleMappingRuleUpdate,
  Secret,
  SecretCreate,
  SecretSetValue,
  Secretschema,
  SecretCreateschema,
  SecretSetValueschema,
  SecretsListResponse,
  CredentialStore,
  CredentialStoreCreate,
  CredentialStoreUpdate,
  CredentialStoresListResponse,
  Me,
  Membership,
  Membershipschema,
  MembershipsListResponse,
  MembershipsListResponseschema,
  MembershipUpdate,
  MembershipStatusEnum,
  MembershipUpdateStatusEnum,
  Userschema,
  User,
  UserSummary,
  AWSCloudWatchLogsIntegration,
  AWSCloudWatchLogsIntegrationCreate,
  AWSCloudWatchLogsIntegrationEnableResponse,
  AWSCloudWatchLogsIntegrationOnboardResponse,
  AWSCloudWatchLogsIntegrationsListResponse,
  AWSFlowLogsIntegration,
  AWSFlowLogsIntegrationCreate,
  AWSFlowLogsIntegrationEnableResponse,
  AWSFlowLogsIntegrationOnboardResponse,
  AWSFlowLogsIntegrationsListResponse,
  AWSFlowLogsResourceOptionsResponse,
  ApiKey,
  ApiKeyCreate,
  ApiKeyCreateResponse,
  ApiKeyUpdate,
  ApiKeysListResponse,
  ApiKeyschema,
  CloudAccessQuickCreateResponse,
  CloudTrailIntegration,
  CloudTrailIntegrationEnableResponse,
  CloudTrailIntegrationOnboardResponse,
  CloudTrailIntegrationsListResponse,
  MetricsIntentQueryRangeRequest,
  MetricsSeriesResponse,
  PasskeyAttestationVerifyResponseschema,
  PasskeyAttestationVerifyRequestCredential,
  PasskeyAssertionVerifyResponseschema,
  PasskeyAssertionVerifyRequestCredential,
  Site,
  Siteschema,
  SiteCreate,
  SiteCreateschema,
  SiteUpdate,
  SiteUpdateschema,
  SitesListResponse,
  SitesListResponseschema,
  ConnectorCluster,
  ConnectorClusterschema,
  ConnectorClusterCreate,
  ConnectorClusterCreateschema,
  ConnectorClusterUpdate,
  ConnectorClusterUpdateschema,
  ConnectorClustersListResponse,
  ConnectorClustersListResponseschema,
  Connector,
  Connectorschema,
  ConnectorCreate,
  ConnectorCreateschema,
  ConnectorUpdate,
  ConnectorUpdateschema,
  ConnectorsListResponse,
  ConnectorsListResponseschema,
  ClusterSitesAttachRequest,
  ClusterSitesAttachResult,
  ClusterSitesDetachRequest,
  ClusterSitesDetachResult,
  TopologyGraph,
  TopologyGraphschema,
  Invitation,
  InvitationCreate,
  InvitationAcceptRequest,
  InvitationAcceptResponse,
  InvitationsListResponse,
  InvitationsListResponseschema,
  Invitationschema,
  InvitationStatusEnum,
  Role,
  RoleCreate,
  RoleUpdate,
  RolesListResponse,
  RolesListResponseschema,
  RoleResolvedschema,
  RoleStatusEnum,
  RoleCreateStatusEnum,
  RoleUpdateStatusEnum,
  PermissionschemaResourceEnum,
  PermissionschemaVerbsEnum,
  Permissionschema,
  Credential,
  CredentialCreate,
  CredentialCreateschema,
  CredentialDetailsCliSshschema,
  CredentialDetailsGnmischema,
  CredentialDetailsSnmpV2cschema,
  CredentialDetailsSnmpV3schema,
  CredentialDetailsApiRestschema,
  CredentialDetailsApiRestAuth,
  CredentialDetailsApiRestAuthApiKey,
  CredentialDetailsApiRestAuthBasic,
  CredentialDetailsApiRestAuthBearer,
  CredentialDetailsApiRestAuthMtls,
  CredentialApiAuthType,
  CredentialKind,
  CredentialUpdate,
  CredentialUpdateDetails,
  CredentialUpdateschema,
  CredentialsListResponse,
  CredentialsListResponseschema,
  CredentialAssignment,
  CredentialAssignmentCreate,
  CredentialAssignmentCreateschema,
  CredentialAssignmentUpdate,
  CredentialAssignmentUpdateschema,
  CredentialAssignmentsListResponse,
  CredentialAssignmentsListResponseschema,
  CredentialAssignmentAllOfMatch,
  CredentialAssignmentAllOfScope,
  DeviceRunningConfigSnapshot,
  DeviceRunningConfigVersion,
  DeviceRunningConfigVersionsListResponse,
  DeviceRunningConfigDiff,
  Device,
  DeviceLifecycleschema,
  DeviceUpdate,
  DeviceUpdateschema,
  DevicesListResponse,
  DevicesListResponseschema,
  AuditEvent,
  AuditEventTypesResponse,
  AuditEventsListResponse,
  AuditEventsListResponseschema,
  DiscoveryJob,
  DiscoveryJobschema,
  DiscoveryJobsListResponse,
  DiscoveryJobCreate,
  DiscoveryJobCreateSchedule,
  DiscoveryJobUpdate,
  DiscoveryJobUpdateschema,
  DiscoveryTriggerScopeschema,
  DiscoveryRun,
  DiscoveryRunsListResponse,
  DiscoveryRunSummaryschema,
  DiscoveryRunAllOfLinks,
  DiscoveryRunAllOfConfigSnapshot,
  DiscoveryRunAllOfConfigSnapshotSchedule,
  DiscoveryEvent,
  DiscoveryEventData,
  DiscoveryEventStatusData,
  DiscoveryEventProgressData,
  DiscoveryEventWarningData,
  DiscoveryEventErrorData,
  DiscoveryEventFinishedData,
  DiscoveryEventHeartbeatData,
  DiscoveryEventDeviceDiscoveredData,
  DiscoveryEventLinkDiscoveredData
} from '../../vendor/openapi-public-v1/dist/esm/models/index.js';

export type ArtifactContentChartschema = any;

export type CloudAccessConnection = {
  id?: string;
  orgId?: string;
  awsAccountId?: string;
  accountId?: string;
  provider?: string;
  type?: string;
  roleName?: string;
  status?: string;
  name?: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export type CloudAccessConnectionsListResponse = {
  items: CloudAccessConnection[];
  meta?: PageMetaschema;
};

const asObject = (value: unknown): Record<string, unknown> | null =>
  value && typeof value === 'object' && !Array.isArray(value) ? (value as Record<string, unknown>) : null;

const readString = (record: Record<string, unknown>, ...keys: string[]): string | undefined => {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === 'string' && value.trim()) {
      return value;
    }
  }
  return undefined;
};

const readNumber = (record: Record<string, unknown>, ...keys: string[]): number | undefined => {
  for (const key of keys) {
    const value = record[key];
    if (typeof value === 'number' && Number.isFinite(value)) {
      return value;
    }
  }
  return undefined;
};

const readRecord = (record: Record<string, unknown>, ...keys: string[]): Record<string, unknown> | undefined => {
  for (const key of keys) {
    const value = asObject(record[key]);
    if (value) {
      return value;
    }
  }
  return undefined;
};

export const ChatRunEventArtifactUpdateschemaFromJSON = (json: unknown): ChatRunEventArtifactUpdateschema => {
  const record = asObject(json) ?? {};

  if (
    !Object.prototype.hasOwnProperty.call(record, 'event_id') &&
    !Object.prototype.hasOwnProperty.call(record, 'artifact_id') &&
    !Object.prototype.hasOwnProperty.call(record, 'artifact_kind') &&
    !Object.prototype.hasOwnProperty.call(record, 'update_kind') &&
    !Object.prototype.hasOwnProperty.call(record, 'workflow_id')
  ) {
    return GeneratedChatRunEventArtifactUpdateschemaFromJSON(json);
  }

  return GeneratedChatRunEventArtifactUpdateschemaFromJSON({
    eventId: readString(record, 'eventId', 'event_id'),
    artifactId: readString(record, 'artifactId', 'artifact_id'),
    artifactKind: readString(record, 'artifactKind', 'artifact_kind'),
    updateKind: readString(record, 'updateKind', 'update_kind'),
    summary: readString(record, 'summary'),
    revision: readNumber(record, 'revision'),
    patch: readRecord(record, 'patch'),
    agent: readRecord(record, 'agent'),
    call: readRecord(record, 'call'),
    workflowId: readString(record, 'workflowId', 'workflow_id')
  });
};
export const TopologyV2ViewOriginFilter = {
  All: 'all',
  System: 'system',
  Custom: 'custom'
} as const;

export type { PageMetaschema } from '../../vendor/openapi-public-v1/dist/esm/models/PageMetaschema.js';

export {
  ConnectorStatusEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/Connector.js';
export {
  DiscoveryJobStatusEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/DiscoveryJob.js';
export {
  DiscoveryRunStatusEnum
} from '../../vendor/openapi-public-v1/dist/esm/models/DiscoveryRun.js';

export type DashboardPageKey = string;

export type DashboardWidgetType = 'grafana_panel_iframe' | string;

export interface DashboardWidgetSpec {
  id: string;
  type: DashboardWidgetType;
  title: string;
  iframeUrl?: string;
  bindings?: {
    vars?: Record<string, string> | string[];
    time?: string[];
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

export interface DashboardsRecommendedGrafanaItem {
  title?: string;
  iframeUrl?: string;
  why?: string;
  [key: string]: unknown;
}

export interface DashboardsRecommendedGrafanaResponse {
  items?: DashboardsRecommendedGrafanaItem[];
}

export interface DashboardsRecommendedResponse {
  pageKey?: string;
  context?: {
    scopeType?: string;
    scopeId?: string;
    [key: string]: unknown;
  };
  widgets?: DashboardWidgetSpec[];
}

export interface DashboardsTemplatesResponse {
  pageKeys?: Array<{
    key?: string;
    title?: string;
    description?: string;
  }>;
  widgetTypes?: Array<{
    type?: string;
    bindings?: {
      vars?: string[];
      time?: string[];
    };
  }>;
  grafanaCatalog?: Array<{
    templateKey?: string;
    dashUid?: string;
    panelId?: number;
    mode?: string;
    vars?: string[];
    timeVars?: string[];
    [key: string]: unknown;
  }>;
  version?: string;
}

export interface TelemetryTarget {
  targetId: string;
  targetLabel: string;
  targetKind: string;
  deviceName?: string;
}

export interface TelemetryTargetsListResponse {
  items?: TelemetryTarget[];
  meta?: PageMetaschema;
}

export interface SignalIncidentschema {
  id: string;
  orgId?: string;
  scopeType?: string;
  scopeId?: string;
  subtype?: string;
  dedupeKey?: string;
  status?: string;
  severity?: string;
  conditionKey?: string;
  instance?: string;
  targetType?: string;
  targetId?: string;
  openedAt?: string;
  updatedAt?: string;
  attributes?: Record<string, unknown> | null;
  title?: string | null;
  [key: string]: unknown;
}

export interface SignalIncidentAnalysisschema {
  summary?: string | null;
  impact?: string | null;
  rationale?: string[];
  nextChecks?: string[];
  [key: string]: unknown;
}

export type SignalIncidentAnalysis = SignalIncidentAnalysisschema;

export type SignalIncidentAttachmentNormalizationStatusschema =
  | 'discovered'
  | 'normalized'
  | 'download_failed'
  | 'import_failed'
  | 'blocked'
  | string;

export interface SignalIncidentAttachmentschema {
  id: string;
  name: string;
  mimeType?: string;
  sizeBytes?: number;
  provider: string;
  providerAttachmentId: string;
  sourceUrl?: string;
  sourceCreatedAt?: string;
  author?: string;
  normalizationStatus: SignalIncidentAttachmentNormalizationStatusschema;
  resourceRef?: string;
  availabilityState?: 'none' | 'text_ready' | 'preview_ready' | 'download_only' | string;
  analysisState?: 'none' | 'partial' | 'ready' | 'failed' | 'stale' | string;
  analysisFamily?: string;
  preferredRep?: string;
  reps?: string[];
  blockedReason?: string;
  [key: string]: unknown;
}

export type SignalIncidentAttachment = SignalIncidentAttachmentschema;

export interface SignalIncidentTopologyIntentschema {
  viewId?: string;
  scopeType?: string;
  scopeId?: string;
  params?: Record<string, unknown>;
  limits?: Record<string, unknown> & {
    rootNodeId?: string;
    hops?: number;
    limitNodes?: number;
    limitEdges?: number;
  };
  reason?: string;
  [key: string]: unknown;
}

export interface SignalIncidentTelemetryIntentschema {
  reason?: string;
  widgets?: DashboardWidgetSpec[];
  [key: string]: unknown;
}

export interface SignalIncident extends SignalIncidentschema {
  description?: string | null;
  createdAt?: string;
  analysis?: SignalIncidentAnalysisschema | null;
  topologyIntent?: SignalIncidentTopologyIntentschema | null;
  telemetryIntent?: SignalIncidentTelemetryIntentschema | null;
  attachments?: SignalIncidentAttachmentschema[] | null;
}

export interface SignalIncidentEventschema {
  id?: string;
  ts: Date | string;
  severity?: string;
  title?: string;
  detail?: string;
  source?: string;
  summary?: string;
  matchReason?: string;
  deviceName?: string;
}

export interface SignalIncidentEventGroupschema {
  ts: Date | string;
  label?: string;
  title?: string;
  severity?: string;
  summary?: string;
  matchReason?: string;
  deviceName?: string;
  events: SignalIncidentEventschema[];
}

export type SignalIncidentEventGroup = SignalIncidentEventGroupschema;

export interface SignalIncidentEventsResponse {
  incidentId?: string;
  from: Date | string;
  to: Date | string;
  groups: SignalIncidentEventGroupschema[];
  items: SignalIncidentEventschema[];
}

export interface SignalTimelineEventschema {
  id?: string | null;
  ts?: string | null;
  at?: string | null;
  title?: string | null;
  detail?: string | null;
  severity?: string | null;
  type?: string | null;
  eventType?: string | null;
  conditionKey?: string | null;
  oldState?: string | null;
  newState?: string | null;
}

export interface SignalIncidentTimelineResponse {
  items?: SignalTimelineEventschema[];
  meta?: PageMetaschema;
}

export interface SignalConditionStateschema {
  id?: string | null;
  conditionKey?: string | null;
  condition?: string | null;
  targetId?: string | null;
  state?: string | null;
  attributes?: Record<string, unknown> | null;
  [key: string]: unknown;
}

export interface Signal {
  orgId?: string;
  scopeType?: string;
  scopeId?: string;
  family?: string;
  signalKey?: string;
  metricName?: string;
  deviceId?: string;
  targetType?: string;
  targetId?: string;
  instance?: string;
  value?: number;
  observedAt?: string;
  attributes?: Record<string, unknown> | null;
}

export interface SignalFeature {
  orgId?: string;
  scopeType?: string;
  scopeId?: string;
  family?: string;
  featureKey?: string;
  deviceId?: string;
  targetType?: string;
  targetId?: string;
  instance?: string;
  value?: number;
  updatedAt?: string;
  attributes?: Record<string, unknown> | null;
}

export interface SignalCondition {
  orgId?: string;
  scopeType?: string;
  scopeId?: string;
  family?: string;
  conditionKey?: string;
  deviceId?: string;
  targetType?: string;
  targetId?: string;
  instance?: string;
  state?: string;
  updatedAt?: string;
  attributes?: Record<string, unknown> | null;
}

export interface SignalWatchlistItemschema {
  id?: string | null;
  topic?: string | null;
  label?: string | null;
  topicKey?: string | null;
  scopeType?: string | null;
  scopeId?: string | null;
  targetId?: string | null;
  attributes?: Record<string, unknown> | null;
  tier?: string | null;
  updatedAt?: string | null;
}

export interface SignalIncidentsListResponse {
  items?: SignalIncidentschema[];
  meta?: PageMetaschema;
}

export interface SignalListResponse {
  items?: Signal[];
  meta?: PageMetaschema;
}

export interface SignalFeaturesListResponse {
  items?: SignalFeature[];
  meta?: PageMetaschema;
}

export interface SignalConditionsListResponse {
  items?: SignalCondition[];
  meta?: PageMetaschema;
}

export interface SignalWatchlistListResponse {
  items?: SignalWatchlistItemschema[];
  meta?: PageMetaschema;
}

export interface OrgsOrgIdGrafanaEmbedSessionPostRequest {
  orgId: string;
}

export interface OrgsOrgIdSignalsGetRequest {
  orgId: string;
  scopeType: string;
  scopeId: string;
  family: string;
  ifNoneMatch?: string;
  limit?: number;
  after?: string;
  before?: string;
  signalKey?: string;
  deviceId?: string;
  /** Contract: reap-contracts/openapi/public/v1/openapi.yaml#/paths/~1orgs~1{orgId}~1signals/get (deviceIds). */
  deviceIds?: string[];
}

export interface OrgsOrgIdSignalsFeaturesGetRequest {
  orgId: string;
  scopeType: string;
  scopeId: string;
  family: string;
  ifNoneMatch?: string;
  limit?: number;
  after?: string;
  before?: string;
  featureKey?: string;
  deviceId?: string;
}

export interface OrgsOrgIdSignalsConditionsGetRequest {
  orgId: string;
  scopeType: string;
  scopeId: string;
  family: string;
  ifNoneMatch?: string;
  limit?: number;
  after?: string;
  before?: string;
  conditionKey?: string;
  deviceId?: string;
  state?: string;
}

export interface OrgsOrgIdDashboardsTemplatesGetRequest {
  orgId: string;
}

export interface OrgsOrgIdDashboardsTelemetryTargetsGetRequest {
  orgId: string;
  scopeType: string;
  scopeId: string;
}

export interface OrgsOrgIdDashboardsRecommendedGetRequest {
  orgId: string;
  pageKey: string;
  scopeType: string;
  scopeId: string;
  from?: string | Date;
  to?: string | Date;
}

export interface OrgsOrgIdSignalsIncidentsGetRequest {
  orgId: string;
  scopeType?: string;
  scopeId?: string;
  limit?: number;
  after?: string;
  before?: string;
  status?: string;
  severity?: string;
  subtype?: string;
}

export interface OrgsOrgIdSignalsIncidentsIncidentIdEventsGetRequest {
  orgId: string;
  incidentId: string;
}

const normalizeDate = (value: unknown): Date => {
  if (value instanceof Date) {
    return value;
  }
  if (typeof value === 'string' || typeof value === 'number') {
    return new Date(value);
  }
  return new Date(0);
};

const toIsoString = (value: string | Date | undefined): string | undefined => {
  if (!value) {
    return undefined;
  }
  return value instanceof Date ? value.toISOString() : value;
};

export class DashboardsApi extends BaseAPI {
  async orgsOrgIdGrafanaEmbedSessionPost(
    requestParameters: OrgsOrgIdGrafanaEmbedSessionPostRequest,
    initOverrides?: RequestInit
  ): Promise<void> {
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/grafana/embed-session`,
        method: 'POST',
        headers: {}
      },
      initOverrides
    );
    return new VoidApiResponse(response).value();
  }

  async orgsOrgIdDashboardsTemplatesGet(
    requestParameters: OrgsOrgIdDashboardsTemplatesGetRequest,
    initOverrides?: RequestInit
  ): Promise<DashboardsTemplatesResponse> {
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/dashboards/templates`,
        method: 'GET',
        headers: {}
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as DashboardsTemplatesResponse).value();
  }

  async orgsOrgIdDashboardsTelemetryTargetsGet(
    requestParameters: OrgsOrgIdDashboardsTelemetryTargetsGetRequest,
    initOverrides?: RequestInit
  ): Promise<TelemetryTargetsListResponse> {
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/dashboards/telemetry-targets`,
        method: 'GET',
        headers: {},
        query: {
          scopeType: requestParameters.scopeType,
          scopeId: requestParameters.scopeId
        }
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as TelemetryTargetsListResponse).value();
  }

  async orgsOrgIdDashboardsRecommendedGet(
    requestParameters: OrgsOrgIdDashboardsRecommendedGetRequest,
    initOverrides?: RequestInit
  ): Promise<DashboardsRecommendedResponse> {
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/dashboards/recommended`,
        method: 'GET',
        headers: {},
        query: {
          pageKey: requestParameters.pageKey,
          scopeType: requestParameters.scopeType,
          scopeId: requestParameters.scopeId,
          ...(toIsoString(requestParameters.from) != null ? { from: toIsoString(requestParameters.from)! } : {}),
          ...(toIsoString(requestParameters.to) != null ? { to: toIsoString(requestParameters.to)! } : {})
        }
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as DashboardsRecommendedResponse).value();
  }
}

export class SignalsApi extends BaseAPI {
  async orgsOrgIdSignalsGet(
    requestParameters: OrgsOrgIdSignalsGetRequest,
    initOverrides?: RequestInit
  ): Promise<SignalListResponse> {
    const headers: Record<string, string> = {};
    if (requestParameters.ifNoneMatch != null) {
      headers['If-None-Match'] = requestParameters.ifNoneMatch;
    }
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/signals`,
        method: 'GET',
        headers,
        query: {
          scopeType: requestParameters.scopeType,
          scopeId: requestParameters.scopeId,
          family: requestParameters.family,
          ...(requestParameters.limit != null ? { limit: requestParameters.limit } : {}),
          ...(requestParameters.after != null ? { after: requestParameters.after } : {}),
          ...(requestParameters.before != null ? { before: requestParameters.before } : {}),
          ...(requestParameters.signalKey != null ? { signalKey: requestParameters.signalKey } : {}),
          ...(requestParameters.deviceId != null ? { deviceId: requestParameters.deviceId } : {}),
          // Contract: reap-contracts OpenAPI defines deviceIds as style=form,
          // explode=false. The promon endpoint reads one CSV query value, so
          // keep this as a single parameter rather than repeated deviceIds.
          ...(requestParameters.deviceIds?.length ? { deviceIds: requestParameters.deviceIds.join(',') } : {})
        }
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as SignalListResponse).value();
  }

  async orgsOrgIdSignalsFeaturesGet(
    requestParameters: OrgsOrgIdSignalsFeaturesGetRequest,
    initOverrides?: RequestInit
  ): Promise<SignalFeaturesListResponse> {
    const headers: Record<string, string> = {};
    if (requestParameters.ifNoneMatch != null) {
      headers['If-None-Match'] = requestParameters.ifNoneMatch;
    }
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/signals/features`,
        method: 'GET',
        headers,
        query: {
          scopeType: requestParameters.scopeType,
          scopeId: requestParameters.scopeId,
          family: requestParameters.family,
          ...(requestParameters.limit != null ? { limit: requestParameters.limit } : {}),
          ...(requestParameters.after != null ? { after: requestParameters.after } : {}),
          ...(requestParameters.before != null ? { before: requestParameters.before } : {}),
          ...(requestParameters.featureKey != null ? { featureKey: requestParameters.featureKey } : {}),
          ...(requestParameters.deviceId != null ? { deviceId: requestParameters.deviceId } : {})
        }
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as SignalFeaturesListResponse).value();
  }

  async orgsOrgIdSignalsIncidentsGetRaw(
    requestParameters: OrgsOrgIdSignalsIncidentsGetRequest,
    initOverrides?: RequestInit
  ): Promise<JSONApiResponse<SignalIncidentsListResponse>> {
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/signals/incidents`,
        method: 'GET',
        headers: {},
        query: {
          ...(requestParameters.scopeType != null ? { scopeType: requestParameters.scopeType } : {}),
          ...(requestParameters.scopeId != null ? { scopeId: requestParameters.scopeId } : {}),
          ...(requestParameters.limit != null ? { limit: requestParameters.limit } : {}),
          ...(requestParameters.after != null ? { after: requestParameters.after } : {}),
          ...(requestParameters.before != null ? { before: requestParameters.before } : {}),
          ...(requestParameters.status != null ? { status: requestParameters.status } : {}),
          ...(requestParameters.severity != null ? { severity: requestParameters.severity } : {}),
          ...(requestParameters.subtype != null ? { subtype: requestParameters.subtype } : {})
        }
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as SignalIncidentsListResponse);
  }

  async orgsOrgIdSignalsIncidentsIncidentIdEventsGet(
    requestParameters: OrgsOrgIdSignalsIncidentsIncidentIdEventsGetRequest,
    initOverrides?: RequestInit
  ): Promise<SignalIncidentEventsResponse> {
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/signals/incidents/${encodeURIComponent(
          String(requestParameters.incidentId)
        )}/events`,
        method: 'GET',
        headers: {}
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => {
      const payload = json as SignalIncidentEventsResponse;
      return {
        ...payload,
        from: normalizeDate(payload.from),
        to: normalizeDate(payload.to),
        groups: (payload.groups ?? []).map((group) => ({
          ...group,
          ts: normalizeDate(group.ts),
          events: (group.events ?? []).map((item) => ({
            ...item,
            ts: normalizeDate(item.ts)
          }))
        })),
        items: (payload.items ?? []).map((item) => ({
          ...item,
          ts: normalizeDate(item.ts)
        }))
      } satisfies SignalIncidentEventsResponse;
    }).value();
  }

  async orgsOrgIdSignalsConditionsGet(
    requestParameters: OrgsOrgIdSignalsConditionsGetRequest & { family: string; ifNoneMatch?: string; after?: string; before?: string; conditionKey?: string; deviceId?: string },
    initOverrides?: RequestInit
  ): Promise<SignalConditionsListResponse> {
    const headers: Record<string, string> = {};
    if (requestParameters.ifNoneMatch != null) {
      headers['If-None-Match'] = requestParameters.ifNoneMatch;
    }
    const response = await this.request(
      {
        path: `/orgs/${encodeURIComponent(String(requestParameters.orgId))}/signals/conditions`,
        method: 'GET',
        headers,
        query: {
          scopeType: requestParameters.scopeType,
          scopeId: requestParameters.scopeId,
          family: requestParameters.family,
          ...(requestParameters.state != null ? { state: requestParameters.state } : {}),
          ...(requestParameters.limit != null ? { limit: requestParameters.limit } : {}),
          ...(requestParameters.after != null ? { after: requestParameters.after } : {}),
          ...(requestParameters.before != null ? { before: requestParameters.before } : {}),
          ...(requestParameters.conditionKey != null ? { conditionKey: requestParameters.conditionKey } : {}),
          ...(requestParameters.deviceId != null ? { deviceId: requestParameters.deviceId } : {})
        }
      },
      initOverrides
    );
    return new JSONApiResponse(response, (json) => json as SignalConditionsListResponse).value();
  }
}

export type SignalsApiClass = SignalsApi;
export type DashboardsApiClass = DashboardsApi;
